<div class="upload-file-container" appDragDrop (onFileDropped)="uploadFile($event)">
  <input hidden type="file" #fileInput (change)="uploadFile($event.target.files)"
         [multiple]="multiple">

  <div class="upload-file" (click)="openFile()" [class.handle-click]="canHandleClick" *ngIf="!uploadCompleted">
    <h4 class="upload-title">{{title}}</h4>
    <div class="upload-file-content">
      <img alt="file icon" class="fa-file" src="https://allya-lib-assets.s3-sa-east-1.amazonaws.com/ng-core/fileupload.svg">
      <div class="upload-file-info" *ngIf="!files.length">
        <span><a>Procure um arquivo</a> ou arraste e solte-o aqui.</span>
        <span class="upload-file-subtitle">{{subtitle}}</span>
      </div>

      <div class="upload-file-info" *ngIf="files.length">
        <div class="upload-file-list" *ngFor="let file of files; let i = index">
          <div class="upload-file-title">{{file.name}}
            <button class="btn-trash" (click)="deleteFile(i)"><i class="fa fa-trash"></i></button>
          </div>
          <span class="upload-file-subtitle">{{humanFileSize(file.size)}}</span>
          <span class="upload-file-warning" *ngIf="disabled">Aguarde todos arquivos serem processados, para fazer um novo upload.</span>
        </div>
      </div>

      <div class="upload-file-actions">
        <button class="btn btn-orange" (click)="sendFile()" [class.btn-disabled]="!files.length || disabled">Bloquear colaboradores</button>
      </div>
    </div>

    <ng-core-loading *ngIf="loading"></ng-core-loading>
  </div>

  <div class="upload-file" *ngIf="uploadCompleted">
    <div class="upload-completed">
      <h4 class="upload-title">Upload finalizado</h4>

      <div class="upload-file-report">
        <div class="upload-file-content">
          <img alt="file icon" class="fa-file" src="https://allya-lib-assets.s3-sa-east-1.amazonaws.com/ng-core/import-error-icon.png">
          <div class="upload-file-info">
            <span>{{blockedUsers?.errors?.length || 0}}
              {{ blockedUsers?.errors?.length === 1 ? 'colaborador não bloqueado' : 'colaboradores não bloqueados' }}</span>
            <span class="upload-file-subtitle">Alguns colaboradores não foram encontrados com os dados enviados. Abaixo é possível ver a
              lista dos colaboradores não bloqueados.</span>
          </div>
        </div>

        <div class="upload-file-content">
          <img alt="file icon" class="fa-file" src="https://allya-lib-assets.s3-sa-east-1.amazonaws.com/ng-core/import-success-icon.png">
          <div class="upload-file-info">
            <span>{{blockedUsers?.success?.length || 0}}
              {{ blockedUsers?.success?.length === 1 ? 'colaborador bloqueado' : 'colaboradores bloqueados' }}
            </span>
            <span class="upload-file-subtitle">Você poderá desbloquear os cadastros no menu "Colaboradores"</span>
          </div>
        </div>
      </div>

      <div class="upload-file-actions">
        <button class="btn btn-orange" (click)="resetUpload()">Enviar outro arquivo</button>
      </div>
    </div>
  </div>

  <div class="upload-file-error" *ngIf="error">
    <h2 class="error-title">{{error?.title}}</h2>
    <p [innerHTML]="error?.message">{{error?.message}}</p>
    <div class="container-button">
      <button class="btn" (click)="resetUpload()">Tentar novamente</button>
    </div>
  </div>
</div>

<div class="error-list" *ngIf="blockedUsers?.errors">
  <h4>Colaboradores não bloqueados</h4>
  <div class="error-item" *ngFor="let error of blockedUsers?.errors; let i = index">

    <div *ngIf="error.email" class="error-label">Linha: {{i+2}} - Email: <b>{{error.email}}</b>
      <div class="error-description">
        <i aria-hidden="true" class="fa fa-exclamation-triangle"></i> Email não encontrado
      </div>
    </div>

    <div *ngIf="error.cpf" class="error-label">Linha: {{i+2}} - CPF: <b>{{error.cpf}}</b>
      <div class="error-description">
        <i aria-hidden="true" class="fa fa-exclamation-triangle"></i> CPF não encontrado
      </div>
    </div>

    <div *ngIf="error.registrationNumber" class="error-label">Linha: {{i+2}} - Matrícula: <b>{{error.registrationNumber}}</b>
      <div class="error-description">
        <i aria-hidden="true" class="fa fa-exclamation-triangle"></i> Matrícula não encontrada
      </div>
    </div>

    <div *ngIf="!error.email && !error.cpf && !error.registrationNumber"
         class="error-label">Linha: {{i+2}} - Atenção: <b>Não foram encontradas as colunas cpf, email e matrícula, verifique se a planilha está correta.</b>
    </div>
  </div>
</div>
